import type { DrillAnswer, DrillSpec } from "../../model/Drill";
import { OptionButton } from "./OptionButton";
import { OptionContent } from "./OptionContent";
import { optionState } from "./optionState";
import { useOptionNote } from "./useOptionNote";
import { useOptionView } from "./useOptionView";

type ChoiceOptionsProps = {
  spec: DrillSpec;
  answer: DrillAnswer;
  graded: boolean;
  locked: boolean;
  onChange: (answer: DrillAnswer) => void;
  // Выбор отправляется сразу; несколько верных — переключатели и «Проверить».
  onPick?: (answer: DrillAnswer) => void;
};

// Варианты-карточки: один верный (`choice`) или несколько (`multi`).
export const ChoiceOptions = ({
  spec,
  answer,
  graded,
  locked,
  onChange,
  onPick,
}: ChoiceOptionsProps) => {
  const view = useOptionView();
  const note = useOptionNote();
  const multi = spec.mechanic === "multi";
  const toggle = (id: string) => {
    if (!multi) {
      const next = { ...answer, option_ids: [id] };
      onChange(next);
      onPick?.(next);
      return;
    }
    const picked = answer.option_ids.includes(id);
    onChange({
      ...answer,
      option_ids: picked
        ? answer.option_ids.filter((optionId) => optionId !== id)
        : [...answer.option_ids, id],
    });
  };
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-3">
      {spec.options.map((option) => {
        const picked = answer.option_ids.includes(option.id);
        const correct = spec.correct_ids.includes(option.id);
        return (
          <OptionButton
            key={option.id}
            state={optionState(picked, correct, graded, multi, spec.close_ids.includes(option.id))}
            pressed={picked}
            locked={locked}
            onClick={() => {
              toggle(option.id);
            }}
          >
            <OptionContent view={view(option)} extra={graded ? note(spec, option) : null} />
          </OptionButton>
        );
      })}
    </div>
  );
};
